import {
  API_STATES
} from '@/helpers'
  
const state = {
  storeMappingUpdateState : API_STATES.NOT_REQUESTED,
  storeMappingUpdateError : null
}

export default state
